<template>
  <div class="managingPeople hp100 bbox " v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <div class="search-box">
        <span style=" font-size: 14px;margin-right: 10px;">统计周期:</span>
        <div class="type-box">
          <span :class="type === 'day' ? 'active' : ''" @click="changeDate('day')">按日</span>
          <span :class="type === 'monthrange' ? 'active' : ''" @click="changeDate('monthrange')"> 按月</span>
          <span :class="type === 'daterange' ? 'active' : ''" @click="changeDate('daterange')">自定义</span>
        </div>
        <span style=" font-size: 14px;margin-right: 10px;">营业周期:</span>
        <el-date-picker v-model="dataTime" :type="type === 'day' ? 'daterange' : type" :format="format"
          :placeholder="placeholder" :picker-options="pickerOptions">
        </el-date-picker>
        <!-- <span style=" font-size: 14px;margin:0 10px;">统计方式:</span>
            <el-select v-model="value" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select> -->
        <el-button type="primary" icon="el-icon-search"
          style="margin-left: 20px;background-color: #f59a23;border: none;" @click="search">查询</el-button>
        <el-button icon="el-icon-refresh" style="margin-left: 20px;" @click="reset">重置</el-button>
      </div>
      <!-- <el-row type="flex" justify="space-between">
        <el-col>
          <div>
            <el-button type="primary" class="sumBtn"
              >总营业额 ：{{ sumDetail.totalSaleFee }}</el-button
            >
          </div>
        </el-col>
        <el-col>
          <div>
            <el-button type="success" class="sumBtn"
              >微信 ：{{ sumDetail.weChatPayFee }}</el-button
            >
          </div>
        </el-col>
        <el-col>
          <div>
            <el-button type="warning" class="sumBtn"
              >支付宝 ：{{ sumDetail.aliPayFee }}</el-button
            >
          </div>
        </el-col>
 
        <el-col>
          <div>
            <el-button type="primary" class="sumBtn"
              >会员卡 ：{{ sumDetail.memberCardPayFee }}</el-button
            >
          </div>
        </el-col>
        <el-col>
          <div>
            <el-button type="success" class="sumBtn"
              >会员充值 ：{{ sumDetail.memberStoredFee }}</el-button
            >
          </div>
        </el-col>
        <el-col>
          <div>
            <el-button type="warning" class="sumBtn"
              >销售数量 ：{{ sumDetail.saleCount }}</el-button
            >
          </div>
        </el-col>
        <el-col>
          <div>
            <el-button type="primary" class="sumBtn"
              >美团券核销 ：{{ sumDetail.meituanFee }}</el-button
            >
          </div>
        </el-col>
        <el-col>
          <div>
            <el-button type="success" class="sumBtn"
              >抖音券核销 ：{{ sumDetail.douyinFee }}</el-button
            >
          </div>
        </el-col>
      </el-row> -->
      <!-- 用户列表区域 -->
      <!-- <div :style="{ height: height + 'px' }" style=" margin-top: 20px;">
        <el-scrollbar style="height: 100%; width: 100%">
          <el-row style="width: 100%"> -->
      <el-table :data="tableData" style="width:100%" border :summary-method="getSummaries" show-summary>
        <el-table-column label="序号" align="center" type="index" width="80px">
        </el-table-column>
        <el-table-column label="销售额" sortable align="center" prop="totalSaleFee" width="140px">
          <template slot-scope="scope">
            <span>{{ scope.row.totalSaleFee }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付宝收款"  align="center" prop="aliPayFee" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.aliPayFee }}</span>
          </template>
        </el-table-column>
        <el-table-column label="微信收款"  align="center" prop="weChatPayFee" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.weChatPayFee }}</span>
          </template>
        </el-table-column>
        <el-table-column label="银行卡收款" align="center" prop="bankCardPayFee" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.bankCardPayFee }}</span>
          </template>
        </el-table-column>
        <el-table-column label="会员卡收款" align="center" prop="memberCardPayFee" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.memberCardPayFee }}</span>
          </template>
        </el-table-column>

        <el-table-column label="会员充值金额" align="center" prop="memberStoredFee" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.memberStoredFee }}</span>
          </template>
        </el-table-column>
        <el-table-column label="美团券核销金额" align="center" prop="mtCouponAmount" width="140px">
          <template slot-scope="scope">
            <span>{{ scope.row.mtCouponAmount || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="抖音券核销金额" align="center" prop="dyCouponAmount" width="140px">
          <template slot-scope="scope">
            <span>{{ scope.row.dyCouponAmount || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="总入账"  align="center" prop="totalEnterFee" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.totalEnterFee }}</span>
          </template>
        </el-table-column>
        <el-table-column label="销售额"  align="center" prop="saleAccount" width="120px">
          <template slot-scope="scope">
            <span>{{ scope.row.saleAccount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="日结日期"  align="center" prop="日结日期" width="140px">
          <template slot-scope="scope">
            <span>{{ scope.row.dailyDt | dataFormat }}</span>
          </template>
        </el-table-column>

        <el-table-column label="交易数量"  align="center" prop="saleCount" width="100px">
          <template slot-scope="scope">
            <span>{{ scope.row.saleCount }}</span>
          </template>
        </el-table-column>
        <el-table-column label="交班现金" align="center" prop="changeCashier" width="100px">
          <template slot-scope="scope">
            <span>{{ scope.row.changeCashier }}</span>
          </template>
        </el-table-column>

      </el-table>
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage" :page-sizes="[10, 20, 30, 50]" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import moment from 'moment/moment';
// 创建一个表示当前日期的 Date 对象
let currentDate = new Date();

// 获取当前日期的天数
let currentDay = currentDate.getDate();

// 将日期减去一天
currentDate.setDate(currentDay - 1);
export default {
  data() {
    return {
      height: window.innerHeight - 256, //表格高度
      value: "",
      dateRange: "",
      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          id: ""
        }
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: ""
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false,

      //统计
      sumDetail: {},
      pickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() >= today.getTime();
        }
      },
      queryInfo: {
        condition: {
        },
        currPage: 1,
        pageCount: 1,
        pageSize: 10,
      },
      dateTime: [],
      type: 'monthrange',
      dataTime: [currentDate, currentDate],
      format: 'yyyy/MM',
      vformat: 'yyyy/MM',
      placeholder: '选择月',
    };
  },
  created() {
    this.queryInfo.currPage = this.$route.query.currPage;
    this.queryInfo.pageSize = this.$route.query.pageSize;
    this.getListData();
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {

    reset() {
      //moment.js 格式化时间
      this.dataTime = [currentDate, currentDate]
      this.search()
    },
    //条件查询
    search() {
      this.getListData();
    },
    changeDate(type) {
      //moment.js 格式化时间
      this.dataTime = [currentDate, currentDate]
      if (type === 'day') {
        this.format = 'yyyy-MM-dd';
        this.vformat = 'YYYY-MM-DD';
        this.placeholder = '选择月';
      } else if (type === 'monthrange') {
        this.format = 'yyyy/MM';
        this.vformat = 'YYYY/MM';
        this.placeholder = '选择月';
      } else if (type === 'daterange') {
        this.format = 'yyyy-MM-dd';
        this.vformat = 'YYYY-MM-DD';
        this.placeholder = '选择日期范围';
      }
      this.type = type;
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() { },
    //跳转到详情
    gotoDetail(id) {
      var that = this;
      this.$router.push({
        path: "/merchantDailyRecords/details",
        query: {
          id: id,
          currPage: that.queryInfo.currPage,
          pageSize: that.queryInfo.pageSize
        }
      });
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(err => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post("/merchantDailyRecord/delete", { id: id })
          .then(function (response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true
            });
            that.getListData();
          });
      }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2);

        } else {
          sums[index] = '--';
        }
      });

      return sums;
    },
    getListData() {
      // 获取列表
      var that = this;
      this.queryInfo.condition = {}
      let timeType = 0
      let startTime = null
      let endTime = null
      let time = null
      let timeTwo = null
      let type = 0
      if (this.type === 'day') {
        type = 1
        if (this.dataTime != null && this.dataTime.length > 0) {
          time = moment(this.dataTime[0]).format(this.vformat)
          timeTwo = moment(this.dataTime[1]).format(this.vformat)
        } else {
          this.$message.error('请选择时间范围')
          return
        }
        this.queryInfo.condition.startTime = time
        this.queryInfo.condition.endTime = timeTwo
        this.queryInfo.condition.timeType = 6
        this.queryInfo.condition.type = type
      } else {
        timeType = this.type === 'monthrange' ? 3 : 6
        if (timeType == 6) {
          if (this.dataTime != null && this.dataTime.length > 0) {
            startTime = moment(this.dataTime[0]).format(this.vformat)
            endTime = moment(this.dataTime[1]).format(this.vformat)
          } else {
            this.$message.error('请选择时间范围')
            return
          }
          this.queryInfo.condition.startTime = startTime
          this.queryInfo.condition.endTime = endTime
          this.queryInfo.condition.timeType = 6
          this.queryInfo.condition.timeType = timeType
          this.queryInfo.condition.type = 0
        } else {
          if (this.dataTime === null || this.dataTime.length == 0) {
            this.$message.error('请选择时间范围')
            return
          }
          time = moment(this.dataTime[0]).format(this.vformat)
          timeTwo = moment(this.dataTime[1]).format(this.vformat)
          this.queryInfo.condition.time = time
          this.queryInfo.condition.timeTow = timeTwo
          this.queryInfo.condition.timeType = timeType
        }
      }
      that.queryInfo.condition.merchantCode = localStorage.getItem(
        "merchantCode"
      );
      that.$http
        .post("/merchantDailyRecord/list", that.queryInfo)
        .then(function (response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
            let total = 0;
            let wxCharge = 0;
            let aliCharge = 0;
            let card = 0;
            let charge = 0;
            let sellNum = 0;
            let meituan = 0;
            let douyin = 0;
            that.tableData.forEach(e => {
              if (e.totalSaleFee) {
                total += parseFloat(e.totalSaleFee);
              }
              if (e.weChatPayFee) {
                wxCharge += parseFloat(e.weChatPayFee);
              }
              if (e.aliPayFee) {
                aliCharge += parseFloat(e.aliPayFee);
              }
              if (e.memberCardPayFee) {
                card += parseFloat(e.memberCardPayFee);
              }
              if (e.memberStoredFee) {
                charge += parseFloat(e.memberStoredFee);
              }
              if (e.saleCount) {
                sellNum += parseFloat(e.saleCount);
              }
              if (e.mtCouponAmount) {
                meituan += parseFloat(e.mtCouponAmount);
              }
              if (e.dyCouponAmount) {
                douyin += parseFloat(e.dyCouponAmount);
              }
            });
            that.sumDetail = {
              totalSaleFee: total.toFixed(2),
              weChatPayFee: wxCharge.toFixed(2),
              aliPayFee: aliCharge.toFixed(2),
              memberCardPayFee: card.toFixed(2),
              memberStoredFee: charge.toFixed(2),
              saleCount: sellNum.toFixed(2),
              meituanFee: meituan.toFixed(2),
              douyinFee: douyin.toFixed(2)
            };
          }
        });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    }
  }
};
</script>

<style lang="scss" scoped>
.block {
  display: flex;
  margin-left: 10px;
}

.search-btn {
  display: flex;
  margin-left: 10px;
  margin-bottom: 20px;
}

.textblue {
  color: #008eff;
}

.managingPeople {
  .el-card {
    height: calc(100vh - 114px);
    position: relative;

    .el-select>.el-input {
      width: 200px;
    }

    .header-search-box .header-search-input {
      width: 325px;
    }

    input::placeholder {
      font-size: 12px;
    }

    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }

    .footerBox {
      width: 100%;
      margin-top: 20px;
    }
  }
}

/deep/.el-scrollbar__view {
  min-width: 100%;
}

/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}

/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}

.managingPeople .el-card {
  height: 90vh !important;
}

.sumBtn {
  height: 80px;
  min-width: 150px;
}


.search-box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 20px;



  .type-box {
    display: flex;
    align-items: center;
    margin-right: 20px;
    justify-content: flex-start;

    span {
      padding: 0 10px;
      cursor: pointer;
      color: #333;
      border: 1px solid #cecece;
      font-size: 14px;
    }

    .active {
      color: #f59a23;
      border: 1px solid #f59a23;
    }
  }
}


/deep/ .el-radio-button__inner:hover {
  color: #f59a23;
}
</style>
